import fetchApi from "../../../../lib/fetchApi";
import { SelectItemDto } from "../../../../types/SelectItemDto";
import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToClaimDeleteReason = mapDictionaryState;

const claimDeleteReasonApi = createDictionaryApiFactory("claimDeleteReason");

export const getClaimDeleteReason = claimDeleteReasonApi.search;
export const getClaimDeleteReasonDetail = claimDeleteReasonApi.getDetail;
export const createClaimDeleteReason = claimDeleteReasonApi.save;
export const exportCsvClaimDeleteReason = claimDeleteReasonApi.exportCsv;

export const getClaimDeleteReasonSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/claimDeleteReason/select`) as SelectItemDto[];
    return response;
}